const StatementBottom = {
  template: /*html*/ `
    <div class="statement-bottom">
      <div class="statement-bottom__btn statement-bottom__btn--back">
        <button v-show="backBtn.show" type="button" class="btn border dark" :class="backBtn.class" @click.prevent="prev"><span>{{backBtn.text}}</span></button>
      </div>
      <div class="statement-bottom__btn statement-bottom__btn--next">
        <button v-show="nextBtn.show" type="submit" class="btn fill primary" :class="[nextBtn.class, {disabled: nextBtn.disabled}]" @click.prevent="next"><span>{{nextBtn.text}}</span></button>
      </div>
    </div>
  `,
  methods:{
    next(){
      this.$emit('next_clicked')
    },
    prev(){
      this.$emit('back_clicked');
    }
  },

  props: {
    nextBtn: {
      type: Object,
      default() {
        return {
          show: false,
          text: "Продолжить",
          class: "",
          disabled: false
        }
      }
    },

    backBtn: {
      type: Object,
      default() {
        return {
          show: false,
          text: "Назад",
          class: "",
          disabled: false
        }
      }
    }
  },
};

export default StatementBottom;